import Vue from 'vue'

const resource = 'pharmacies'

const getAll = (params = {}) => Vue.axios(`${resource}`, {params})
const getRecents = (params = {}) => Vue.axios(`${resource}/recents`, {params})
const getCalendar = (id, params) => Vue.axios(`${resource}/${id}/calendars`, {params})
const getClaimantsInvoiceIndex = (headers = {}) => Vue.axios.get(`${resource}/invoices`, {headers})

export default {
  getAll,
  getRecents,
  getCalendar,
  getClaimantsInvoiceIndex
}



// WEBPACK FOOTER //
// ./src/api/pharmacies.js